import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
// import {
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  CloseSquareOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import MerchantReportOrderDetails from "./MerchantReportOrderDetails";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import MerchantReading from "./MerchantReading";
import { NotificationInfo } from "../../../../../context";

const MerchantReports = ({ user_id, merchant_name }) => {
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [totalGross, setTotalGross] = useState(0);
  const [totalDineIn, setTotalDineIn] = useState(0);
  const [totalTakeOut, setTotalTakeOut] = useState(0);
  const [totalPickup, setTotalPickup] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  const [totalECash, setTotalECash] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const [detectFilter, setDetectFilter] = useState(false);
  const [openReaderDrawer, setOpenReaderDrawer] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Date",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      sorter: (a, b) => a.transaction_id - b.transaction_id,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      // title: "Table Number",
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "right",
      render: (text, record) => (
        <p>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 80 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderSaveList = useCallback(() => {
    var params = {
      user_id,
      status: 1,
      orderby: "desc",
      order_category: "products",
    };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;

        const res = _.chain(data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            cost: getTotalCost(value),
            dine_in: getTotalDineIn(value),
            take_out: getTotalTakeOut(value),
            pick_up: getTotalPickUp(value),
            cash: getTotalCash(value),
            ecash: getTotalECash(value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantOrderSaveList({ data: res2, ready: true });
        setTotalGross(calculateTotal(res, "gross"));
        setTotalDineIn(calculateTotal(res, "dinein"));
        setTotalTakeOut(calculateTotal(res, "takeout"));
        setTotalPickup(calculateTotal(res, "pickup"));
        setTotalCash(calculateTotal(res, "cash"));
        setTotalECash(calculateTotal(res, "ecash"));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [user_id]);

  const getTotalCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const getTotalDineIn = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].service_category === "dine") {
        total += parseInt(data[i].quantity) * parseFloat(data[i].price);
      }
    }
    return total;
  };

  const getTotalTakeOut = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].service_category === "takeout") {
        total += parseInt(data[i].quantity) * parseFloat(data[i].price);
      }
    }
    return total;
  };

  const getTotalPickUp = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].service_category === "pickup") {
        total += parseInt(data[i].quantity) * parseFloat(data[i].price);
      }
    }
    return total;
  };

  const getTotalCash = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].payment_method === "cash") {
        total += parseInt(data[i].quantity) * parseFloat(data[i].price);
      }
    }
    return total;
  };

  const getTotalECash = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].payment_method === "ecash") {
        total += parseInt(data[i].quantity) * parseFloat(data[i].price);
      }
    }
    return total;
  };

  useEffect(() => {
    getMerchantOrderSaveList();
  }, [getMerchantOrderSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from)).format("YYYY-MM-DD"),
      date_to: moment(new Date(values.date_to)).format("YYYY-MM-DD"),
      user_id,
      status: 1,
      orderby: "desc",
    };
    setDateFrom(values.date_from);
    setDateTo(values.date_to);
    setLoading(true);
    axios
      .get("user/merchant/filter/customer-order-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          const res = _.chain(data)
            .groupBy((g) => g.transaction_id)
            .map((value, key) => ({
              transaction_id: key,
              data: value,
              customer_name: value[0].customer_name,
              created_at: value[0].created_at,
              table_no: value[0].table_no,
              service_category: value[0].service_category,
              cost: getTotalCost(value),
              dine_in: getTotalDineIn(value),
              take_out: getTotalTakeOut(value),
              pick_up: getTotalPickUp(value),
              cash: getTotalCash(value),
              ecash: getTotalECash(value),
            }))
            .value();
          const res2 = _.orderBy(res, ["created_at"], ["desc"]);
          setMerchantOrderSaveList({ data: res2, ready: true });
          setTotalGross(calculateTotal(res, "gross"));
          setTotalDineIn(calculateTotal(res, "dinein"));
          setTotalTakeOut(calculateTotal(res, "takeout"));
          setTotalPickup(calculateTotal(res, "pickup"));
          setTotalCash(calculateTotal(res, "cash"));
          setTotalECash(calculateTotal(res, "ecash"));

          setOpenFilterByDate(false);
          setLoading(false);
          setDetectFilter(true);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  const calculateTotal = (data, mode) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (mode === "gross") {
        total += parseFloat(data[i].cost) * 1;
      }
      if (mode === "dinein") {
        total += parseFloat(data[i].dine_in) * 1;
      }
      if (mode === "takeout") {
        total += parseFloat(data[i].take_out) * 1;
      }
      if (mode === "pickup") {
        total += parseFloat(data[i].pick_up) * 1;
      }
      if (mode === "cash") {
        total += parseFloat(data[i].cash) * 1;
      }
      if (mode === "ecash") {
        total += parseFloat(data[i].ecash) * 1;
      }
    }
    return total;
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            style={{ marginRight: 10 }}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>

        <Tooltip title="Reading">
          <Button
            type="default"
            shape="circle"
            onClick={() => {
              setOpenReaderDrawer(true);
            }}
            icon={<QuestionCircleOutlined />}
            disabled={!detectFilter}
          />
        </Tooltip>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
          summary={() => (
            <Table.Summary fixed={"bottom"}>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={6} align="right">
                  <p style={{ fontWeight: "bold" }}>
                    Total:{" "}
                    {totalGross.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </div>

      {openDrawer && (
        <MerchantReportOrderDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
          user_id={user_id}
        />
      )}

      {openReaderDrawer && (
        <MerchantReading
          open={openReaderDrawer}
          close={() => setOpenReaderDrawer(false)}
          totalGross={totalGross}
          totalDineIn={totalDineIn}
          totalTakeOut={totalTakeOut}
          totalPickup={totalPickup}
          totalCash={totalCash}
          totalECash={totalECash}
          data={merchantOrderSaveList}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="storeadmin-report-filter"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MerchantReports;
